export const VIEW_MODE = 'view';
export const EDIT_MODE = 'edit';
export const NEW_MODE = 'new';
export const COLLAPSED_MODE = 'collapsed';
export const COPY_MODE = 'copy'; // copy mode is when copying calendars from other projects
export const CLONE_MODE = 'clone'; // clone mode is when copying calendars from the current project
export const OTHER_PROJECT_CALENDARS_EDIT_MODE = 'other_project_calendars_edit_mode'; // edit mode for other project calendars

export const MINUTE = 60 * 1000; // 1 minute in milliseconds

export const HOUR = 60 * MINUTE;

export const MAX_GOAL_HOUR = 10000 * HOUR;

// Field error types
export const INVALID_FORMAT = 'INVALID_FORMAT';

export const METRICS_PAGE_ID = 'servicedesk.sla.list';
export const ASIA_KOLKATA = 'Asia/Kolkata';
